import { useState } from 'react'
import { X } from 'lucide-react'

import { cn } from '@/lib/utils'
import { Button } from '@/components/ui/button'

interface UpdateBannerProps {
  className?: string
  onUpdate?: () => void
}

export function UpdateBanner({ className, onUpdate }: UpdateBannerProps) {
  const [isVisible, setIsVisible] = useState(true)

  const dismissBanner = () => {
    setIsVisible(false)
  }

  const handleUpdate = () => {
    dismissBanner()
    onUpdate?.()
  }

  if (!isVisible) return null

  return (
    <div
      className={cn(
        'fixed inset-x-0 bottom-0 z-50 border-t bg-white p-4 shadow-[0_-8px_30px_rgba(0,0,0,0.12)] transition-transform duration-300 ease-in-out dark:border-gray-700 dark:bg-gray-800',
        className
      )}
    >
      <div className="container mx-auto flex items-center justify-between rounded-lg bg-white/50 p-2 backdrop-blur-sm dark:bg-gray-800/50">
        <p className="text-sm font-medium">
          Una nuova versione è disponibile. Aggiorna ora per accedere alle
          ultime funzionalità e miglioramenti.
        </p>
        <div className="flex items-center gap-2">
          <Button onClick={handleUpdate} variant="default" size="sm">
            Aggiorna
          </Button>
          <Button
            onClick={dismissBanner}
            variant="ghost"
            size="icon"
            className="size-8"
            aria-label="Dismiss"
          >
            <X className="size-4" />
          </Button>
        </div>
      </div>
    </div>
  )
}
